export const PROJECT_VIEWS = ['card', 'list'] as const;

export type ProjectView = (typeof PROJECT_VIEWS)[number];

const STORAGE_KEY = 'hive.projects.view';

export function isProjectView(value: string | null): value is ProjectView {
  return value !== null && (PROJECT_VIEWS as readonly string[]).includes(value);
}

/**
 * Storage access is wrapped because localStorage throws rather than no-ops when
 * the browser blocks site data; a lost preference must not take the page down.
 */
export function readStoredView(): ProjectView {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return isProjectView(stored) ? stored : 'card';
  } catch {
    return 'card';
  }
}

export function storeView(view: ProjectView): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, view);
  } catch {
    /* Preference is a nicety, not worth surfacing an error for. */
  }
}
